import { getCoverageQueryParam } from "Components/Features/CheckPrice/checkPriceQueryParamUtils";
import { PregnantAndNewbornCoverageQueryParam } from "Components/Features/CheckPrice/checkPriceTypes";

export function childBornFromQueryParams(): boolean | undefined {
  const coverage = getCoverageQueryParam();
  switch (coverage) {
    case PregnantAndNewbornCoverageQueryParam.NEWBORN:
      return true;
    case PregnantAndNewbornCoverageQueryParam.PREGNANT:
      return false;
    default:
      return undefined;
  }
}
